/**
 * 404 page.
 */

import React from 'react';

export function NotFound() {
  return (
    <div className="not-found">
      <h1>404</h1>
      <p>Page not found.</p>
      <a href="/">Back to Dashboard</a>
    </div>
  );
}
